const CATEGORIES = {
    PROGRAMMING_TECH: 10
};

const SUB_CATEGORIES = {
    VOICE_OVERS: 16,
    SOCIAL_MARKETING: 67,
    ASTROLOGY_AND_PSYCHICS: 78,
    SPIRITUAL_AND_HEALING: 79,
    BUY_VIDEO_TESTIMONIALS: 101,
    RESUMES_COVER_LETTERS: 112,
    PROOFREADING: 114,
    WEB_MOBILE_DESIGN: 151,
    WHITEBOARD_EXPLAINER_VIDEOS: 228,
    UNBOXING_VIDEOS: 427,
    CRYPTOCURRENCY: 464
};

const NESTED_SUB_CATEGORIES = {
    CALL_CENTER_AND_CALLING: 2347
};

module.exports = {
    CATEGORIES,
    SUB_CATEGORIES,
    NESTED_SUB_CATEGORIES
};
